import React, { useState, useEffect } from 'react';
import { useApp } from '../data/ColisContext';
import { BRAND } from '../data/constants';
import { focusInput, blurInput, inputStyle } from '../utils/helpers';

export default function ModalAffecter({ colisId, onClose }) {
  const { user, colis, adminColis, affecterLivreur } = useApp();
  const [livreur, setLivreur] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [shareUrl, setShareUrl] = useState('');

  const list = user?.is_admin ? adminColis : colis;
  const pkg = list.find(c => String(c.id) === String(colisId));

  useEffect(() => {
    if (colisId) {
      setLivreur('');
      setSaving(false);
      setErr('');
      /* SUIVI EN DIRECT (pause)
      const token = pkg?.meta?.live_token || '';
      if (token) {
        const url = `${window.location.origin}/livreur?code=${encodeURIComponent(pkg?.id || colisId)}&token=${encodeURIComponent(token)}`;
        setShareUrl(url);
      } else {
        setShareUrl('');
      }
      */
      setShareUrl('');
    }
  }, [colisId, pkg?.id, pkg?.meta?.live_token]);

  if (!colisId) return null;

  const handleConfirm = async () => {
    if (!livreur.trim() || saving) return;
    setSaving(true);
    setErr('');
    try {
      const updated = await affecterLivreur(colisId, livreur.trim());
      /* SUIVI EN DIRECT (pause)
      const token = updated?.meta?.live_token || '';
      if (token) {
        const url = `${window.location.origin}/livreur?code=${encodeURIComponent(updated?.id || colisId)}&token=${encodeURIComponent(token)}`;
        setShareUrl(url);
      } else {
        setShareUrl('');
      }
      */
      setShareUrl('');
    } catch (e) {
      setErr(e?.message || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div
      style={{
        position:       'fixed',
        inset:          0,
        background:     'rgba(0,0,0,0.5)',
        zIndex:         1000,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        padding:        20,
        backdropFilter: 'blur(4px)',
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{
        background:   'white',
        borderRadius: 20,
        padding:      32,
        width:        '100%',
        maxWidth:     420,
        boxShadow:    '0 24px 64px rgba(0,0,0,0.2)',
        animation:    'fadeIn 0.2s ease-out',
      }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 6 }}>
          🛵 Affecter un livreur
        </div>

        {!pkg && (
          <div style={{
            background: '#FFF7ED',
            border: '1px solid #FED7AA',
            borderRadius: 14,
            padding: '10px 12px',
            color: '#9A3412',
            fontWeight: 800,
            marginBottom: 14,
            fontSize: 13,
          }}>
            Colis introuvable dans la liste. Recharge la page puis réessaie.
          </div>
        )}

        {!!err && (
          <div style={{
            background: '#FEF2F2',
            border: '1px solid #FECACA',
            borderRadius: 14,
            padding: '10px 12px',
            color: '#991B1B',
            fontWeight: 800,
            marginBottom: 14,
            fontSize: 13,
          }}>
            {err}
          </div>
        )}

        {!!shareUrl && (
          <div style={{
            background: '#EEF2FF',
            border: '1px solid #C7D2FE',
            borderRadius: 14,
            padding: '12px 12px',
            marginBottom: 14,
          }}>
            <div style={{ fontSize: 12, fontWeight: 900, color: '#3730A3', marginBottom: 8 }}>
              Lien pour le livreur (partage position)
            </div>
            <div style={{
              fontSize: 12,
              fontWeight: 800,
              color: '#0f172a',
              wordBreak: 'break-all',
              background: 'rgba(255,255,255,0.7)',
              border: '1px solid rgba(99,102,241,0.25)',
              borderRadius: 12,
              padding: '10px 10px',
              marginBottom: 10,
            }}>
              {shareUrl}
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(shareUrl);
                  } catch {
                    // ignore
                  }
                }}
                style={{
                  padding: '10px 12px',
                  borderRadius: 12,
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 900,
                  fontFamily: 'inherit',
                  background: BRAND.gradient,
                  color: 'white',
                }}
              >
                📋 Copier
              </button>
              <a
                href={shareUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  padding: '10px 12px',
                  borderRadius: 12,
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 900,
                  fontFamily: 'inherit',
                  background: '#F1F5F9',
                  color: '#0f172a',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                🔗 Ouvrir
              </a>
            </div>
          </div>
        )}
        {!!pkg && (
          <div style={{ fontSize: 13, color: '#64748b', marginBottom: 24 }}>
            Colis <strong style={{ color: BRAND.primary }}>{pkg.id}</strong> → Zone {pkg.zone}
          </div>
        )}

        {/* Infos colis */}
        {!!pkg && (
          <div style={{ background: '#f8fafc', borderRadius: 12, padding: '12px 16px', marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: '#475569' }}>
              <span style={{ fontWeight: 600 }}>Destinataire :</span> {pkg.destinataire}
            </div>
            <div style={{ fontSize: 13, color: '#475569', marginTop: 4 }}>
              <span style={{ fontWeight: 600 }}>Adresse :</span> {pkg.adresse}
            </div>
          </div>
        )}

        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: 'block', fontSize: 12, fontWeight: 700, color: '#475569',
            marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.8px',
          }}>
            Nom du livreur *
          </label>
          <input
            autoFocus
            value={livreur}
            onChange={e => setLivreur(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Ex: Cheikh Mbaye"
            style={inputStyle}
            onFocus={focusInput}
            onBlur={blurInput}
            disabled={!pkg}
          />
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={handleConfirm}
            disabled={!pkg || !livreur.trim() || saving}
            style={{
              flex:         1,
              padding:      '13px',
              background:   pkg && livreur.trim() && !saving ? BRAND.gradient : '#e2e8f0',
              color:        pkg && livreur.trim() && !saving ? 'white'         : '#94a3b8',
              border:       'none',
              borderRadius: 12,
              fontWeight:   700,
              fontSize:     14,
              cursor:       pkg && livreur.trim() && !saving ? 'pointer' : 'not-allowed',
              fontFamily:   'inherit',
              transition:   'all 0.2s',
            }}
          >
            {saving ? '...' : '✅ Confirmer l\'affectation'}
          </button>
          <button
            onClick={onClose}
            style={{
              padding:      '13px 20px',
              background:   '#f1f5f9',
              color:        '#475569',
              border:       'none',
              borderRadius: 12,
              fontWeight:   600,
              fontSize:     14,
              cursor:       'pointer',
              fontFamily:   'inherit',
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
